import Overlay from "@/components/Overlay";

export default function Home() {
  return (
    <div
      data-testid="home-root"
      style={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        background: "#03030A",
      }}
    >
      {/* Decorative slow-rotating mandala watermark & film grain (static CSS, no WebGL) */}
      <div className="mandala-watermark" />
      <div className="grain-overlay" />

      <div style={{ position: "relative", width: "100%", zIndex: 3 }}>
        <Overlay />
      </div>
    </div>
  );
}
